import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Page } from "@components/atoms/page";
import { Subtitle } from "@components/atoms/subtitle";
import { useTableParams } from "@components/organisms/pageTable";
import type { IAppointmentVisitTypes } from "@api/appointment";
import { useAppointmentTable } from "@api/appointment";
import { Statistics } from "@components/organisms/statistics";
import { useSetFilter } from "@hooks";
import { AppointmentTable } from "@/templates/appointmentManagement";
import { AvailableDoctorList } from "@/templates/availableDoctorList";
import { path } from "@/routes/path";
import { Separator } from "@/components/atoms/separator";

export function Component() {
  const { t } = useTranslation("common");

  const navigate = useNavigate();

  const {
    paginationValues,
    searchValue,
    filterValues,
    tableProps,
    setFilters,
  } = useTableParams({
    tabs: [
      { key: "online_visit", title: t("pageTitle.onlineVisits") },
      { key: "in_person_visit", title: t("pageTitle.inPersonVisits") },
    ],
  });
  const { currentPage, resultsPerPage } = paginationValues;

  const { data, isLoading, isFetching, isError } = useAppointmentTable({
    variables: {
      page: currentPage,
      per_page: resultsPerPage,
      filter: searchValue,
      visit_types: [
        (tableProps?.tabProps?.selectedKey as IAppointmentVisitTypes) ||
          "online_visit",
      ],
      time: "today",

      ...filterValues,
    },
  });

  useSetFilter({ filters: data?.data?.filters, setFilters });

  const stats = data?.data?.statistics;

  return (
    <Page>
      <Statistics data={stats || []} isLoading={isLoading} isError={isError} />

      <Subtitle title={"doctorList"} />
      <AvailableDoctorList
        showVisitType={"all"}
        layout={"Grid"}
        onSelect={(visitType, _cost, item) => {
          navigate(
            path.appointment.create.link(
              visitType === "in_person_visit"
                ? "in-person-visit"
                : "online-visit",
              {
                doctorId: item.id.toString(),
              },
            ),
          );
        }}
      />
      <Separator />
      <Subtitle title={"my_visit_today"} />
      <AppointmentTable
        type={"all"}
        data={data?.data?.page?.list || []}
        total={data?.data?.page?.total || 0}
        isLoading={isLoading}
        isFetching={isFetching}
        tableParamProps={tableProps}
        isError={isError}
      />
    </Page>
  );
}
